import { render } from "./dgi.vue?vue&type=template&id=50ad7fbc&scoped=true"
import script from "./dgi.vue?vue&type=script&lang=js"
export * from "./dgi.vue?vue&type=script&lang=js"

import "./dgi.vue?vue&type=style&index=0&id=50ad7fbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ad7fbc"]])

export default __exports__